import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchBooks from "../redux/books/thunk/fetchBooks";
import { filter as bookFilter } from "../redux/filters/actions";
import BookCard from "./BookCard";

export default function BookList() {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filters.filter);
  const books = useSelector((state) => state.books);
  const filteredBook = useSelector((state) => state.filters.searchQuery);

  useEffect(() => {
    dispatch(fetchBooks);
  }, [dispatch]);

  const filteredBooks =
    filter === "featured"
      ? books.books?.filter((book) => book.featured)
      : filteredBook
      ? books.books?.filter(
          (book) =>
            book.name.toLowerCase().includes(filteredBook.toLowerCase()) ||
            book.author.toLowerCase().includes(filteredBook.toLowerCase())
        )
      : books.books;

  const setFilterHandler = (filter) => {
    dispatch(bookFilter(filter));
  };

  return (
    <div className="order-2 xl:-order-1">
      <div className="flex items-center justify-between mb-12">
        <h4 className="mt-2 text-xl font-bold">Book List</h4>

        <div className="flex items-center space-x-4">
          <button
            className={`filter-btn ${filter === "all" ? "active-filter" : ""}`}
            id="lws-filterAll"
            onClick={() => setFilterHandler("all")}
          >
            All
          </button>
          <button
            className={`filter-btn ${
              filter === "featured" ? "active-filter" : ""
            }`}
            id="lws-filterFeatured"
            onClick={() => setFilterHandler("featured")}
          >
            Featured
          </button>
        </div>
      </div>
      <div className="lws-bookContainer">
        {/* <!-- BOOK Card --> */}
        {filteredBooks?.length > 0 ? (
          filteredBooks.map((book) => <BookCard key={book.id} book={book} />)
        ) : (
          <p>Because of Ukraine war. Books are not available.</p>
        )}
      </div>
    </div>
  );
}
